export const now = () => new Date().toISOString().slice(0, 10)

export const stamp = () => new Date().toISOString()
